/* @ngInject */
export default class {
  constructor($q, $window) {
    this.$q = $q;
    if (typeof swal === 'undefined' || typeof $window.swal === 'undefined')
      throw new ReferenceError('swal is not defined');

    this.swal = $window.swal;

    this.colors = {
      error: {
        confirmButtonColor: '#ed5565',
        cancelButtonColor: '#C4C4C4'
      },
      info: {
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#C4C4C4'
      },
      select: {
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#3085d6'
      },
      success: {
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#C4C4C4'
      },
      warning: {
        confirmButtonColor: '#ed5565',
        cancelButtonColor: '#C4C4C4'
      }
    };
  }

  alert(title = '', text = '', type = 'success', timer = 10000) {
    return this.$q(resolve => {
      this.swal({
        type,
        title,
        text,
        timer
      })
        .then(resolve)
        // swal catch will always be a success response
        .catch(resolve);
    });
  }

  fire(title = '', text = '', input, inputOptions, type = 'success') {
    return this.$q(resolve => {
      this.swal
        .fire({
          title,
          text,
          input,
          inputOptions
        })
        .then(resolve)
        // swal catch will always be a success response
        .catch(resolve);
    });
  }

  html(title = '', html = '', type = 'success', timer = 10000) {
    return this.$q(resolve => {
      this.swal({
        type,
        title,
        html,
        timer
      })
        .then(resolve)
        // swal catch will always be a success response
        .catch(resolve);
    });
  }

  confirm(title = '', text = '', type = 'info', confirmButtonText = 'Yes', cancelButtonText = 'Cancel') {
    const { confirmButtonColor, cancelButtonColor } = this.colors[type];
    return this.$q((resolve, reject) => {
      this.swal({
        title,
        text,
        type,
        confirmButtonColor,
        cancelButtonColor,
        showCancelButton: true,
        cancelButtonText,
        confirmButtonText
      })
        .then(response => {
          if (response.value) return resolve(response);
          reject(response);
        })
        .catch(reject);
    });
  }

  confirmHtml(title = '', html = '', type = 'info', confirmButtonText = 'Yes', cancelButtonText = 'Cancel') {
    const { confirmButtonColor, cancelButtonColor } = this.colors[type];
    return this.$q((resolve, reject) => {
      this.swal({
        title,
        html,
        type,
        confirmButtonColor,
        cancelButtonColor,
        showCancelButton: true,
        cancelButtonText,
        confirmButtonText
      })
        .then(response => {
          if (response.value) return resolve(response);
          reject(response);
        })
        .catch(reject);
    });
  }

  delete() {
    return this.$q((resolve, reject) => {
      this.swal({
        title: 'Are you sure?',
        text: "You won't be able to revert this!",
        type: 'error',
        confirmButtonColor: '#ed5565',
        cancelButtonColor: '#C4C4C4',
        showCancelButton: true,
        cancelButtonText: 'Cancel',
        confirmButtonText: 'Yes, Delete it!'
      })
        .then(response => {
          if (response.value) return resolve(response);
          reject(response);
        })
        .catch(reject);
    });
  }

  checkBox(title = '', text = '', confirmButtonText = 'Submit', inputPlaceholder = '') {
    return this.$q((resolve, reject) => {
      this.swal({
        title,
        text,
        confirmButtonText,
        input: 'checkbox',
        inputPlaceholder,
        showCancelButton: true
      })
        .then(resolve)
        .catch(reject);
    });
  }

  input(title = '', text = '', inputPlaceholder = '', input = 'text', validator) {
    return this.$q((resolve, reject) => {
      const params = {
        title,
        text,
        input,
        showCancelButton: true,
        inputPlaceholder
      };

      if (validator) params.inputValidator = validator;

      this.swal(params)
        .then(resolve)
        .catch(reject);
    });
  }

  toast(title = '', type = 'success', timer = 3000) {
    return this.$q((resolve, reject) => {
      this.swal({
        toast: true,
        position: 'top-end',
        showConfirmButton: false,
        timer,
        type,
        title
      })
        .then(resolve)
        .catch(reject);
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/services/Swal.js